export default "__VITE_ASSET__DH1k5eb2__"